import { memo, useEffect, useState } from 'react';

import { Avatar } from 'antd';

import classNames from 'classnames';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import styles from '../Messages.module.scss';

import AvatarPlaceholder from '@/assets/images/PortraitPlaceholder.png';

const getLogoByBotName = botName => {
  switch (botName) {
    case 'Помощник-методист':
      return '/assets/img/icons/female-teach.svg';
    case 'Консультант по развитию':
      return '/assets/img/icons/rocket.svg';
    case 'Changelog Bot':
      return '/assets/img/icons/bell.svg';
    default:
      return AvatarPlaceholder;
  }
};

const ThinkingMessage = ({ data, containerRef }) => {
  const [mounted, setMounted] = useState(false);

  console.log('🤔 ThinkingMessage rendering with data:', data);

  useEffect(() => {
    setMounted(true);
    // Auto scroll to new thinking message for column-reverse
    if (containerRef?.current) {
      setTimeout(() => {
        containerRef.current.scrollTop = 0; // Scroll to top for column-reverse
      }, 100);
    }
  }, [containerRef]);

  // Определяем тип сообщения и соответствующий стиль
  const isWaiting = data.messageData?.isWaiting;
  const isExtended = data.messageData?.isExtended;
  const isTimeout = data.messageData?.isTimeout;
  const extensionCount = data.messageData?.extensionCount || 0;

  // Выбираем иконку или анимацию в зависимости от состояния
  const renderThinkingContent = () => {
    if (isWaiting || isTimeout) {
      return (
        <div className={styles.thinking}>
          <span className={styles.thinking__text}>{data.messageData.content || '⏳ Ожидаю ответ...'}</span>
          <div className={styles.thinking__pulse}>
            <span className={styles.thinking__pulseIcon}>⏳</span>
          </div>
        </div>
      );
    }

    if (isExtended) {
      return (
        <div className={styles.thinking}>
          <span className={styles.thinking__text}>
            {data.messageData.content || '⏳ Обработка занимает больше времени...'}
          </span>
          {extensionCount > 0 && <span className={styles.thinking__extension}>(продление {extensionCount})</span>}
          <div className={styles.thinking__extended}>
            <span className={styles.thinking__extendedIcon}>🔄</span>
          </div>
        </div>
      );
    }

    // Обычное thinking сообщение
    return (
      <div className={styles.thinking}>
        <span className={styles.thinking__text}>{'🤔 Думаю '}</span>
        <div className={styles.thinking__dots}>
          <span className={styles.thinking__dot}></span>
          <span className={styles.thinking__dot}></span>
          <span className={styles.thinking__dot}></span>
        </div>
      </div>
    );
  };

  return (
    <div
      className={classNames(styles.message, styles.message_thinking, {
        [styles.message_fadeIn]: mounted,
        [styles.message_waiting]: isWaiting,
        [styles.message_extended]: isExtended,
        [styles.message_timeout]: isTimeout,
      })}
    >
      <div className={styles.message__box}>
        <Avatar
          shape='square'
          src={data?.messageData?.isBot ? getLogoByBotName(data?.userData?.firstName) : AvatarPlaceholder}
        />
        <div className={classNames(styles.message__content, styles.message__content_thinking)}>
          <p className={styles.message__name}>
            {data.userData?.firstName} {data.userData?.lastName}
          </p>
          <div className={styles.message__container}>
            {renderThinkingContent()}
            <p className={styles.message__time}>{dayjs(data.messageData.createdAt).format('HH:mm')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

ThinkingMessage.propTypes = {
  data: PropTypes.shape({
    messageData: PropTypes.shape({
      content: PropTypes.string,
      createdAt: PropTypes.string,
      messageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isThinking: PropTypes.bool,
      isWaiting: PropTypes.bool,
      isExtended: PropTypes.bool,
      isTimeout: PropTypes.bool,
      extensionCount: PropTypes.number,
    }),
    userData: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  }),
  containerRef: PropTypes.object,
};

export default memo(ThinkingMessage);
